import {
  SEARCH_BOX_CLEAN_HISTORY_CLICK,
  SEARCH_BOX_QUERY_SUGGESTION_CLICK,
  SEARCH_BOX_SUGGESTED_PRODUCT_CLICK,
  SERP_PRE_QUERY_SUGGESTIONS,
} from 'shared/experiments/consts'
import {
  activateExperiment,
  getExperimentOnClient,
} from 'shared/experiments/utils/experiments'
import trackOptimizelyEvent from 'shared/experiments/utils/trackOptimizelyEvent'
import store from 'shared/store'
import { EXCLUDED_PAGE_TYPES } from 'views/components/organisms/PreQuerySuggestions/consts'

export default () => {
  const { pageType } =
    store.getState()?.publicRuntimeConfig.pageProperties || {}
  const { isEnabled } = getExperimentOnClient(SERP_PRE_QUERY_SUGGESTIONS)

  if (!isEnabled || EXCLUDED_PAGE_TYPES.includes(pageType)) return

  void activateExperiment(SERP_PRE_QUERY_SUGGESTIONS)

  const preQueryWrapper = document.querySelector(
    '.o-PreQuerySuggestLayer__wrapper'
  )
  const mobilePreQueryWrapper = document.querySelector(
    '[data-clientside-hook~="SearchBoxMobileContainer"]'
  )

  const trackEvents = (event: Event) => {
    const target = <HTMLElement>event.target

    if (target.closest('[data-clientside-hook~="SearchBoxListItemLink_PQ"]')) {
      trackOptimizelyEvent(SEARCH_BOX_SUGGESTED_PRODUCT_CLICK)
    }
    if (target.closest('[data-clientside-hook~="SearchBoxListSuggestLink"]')) {
      trackOptimizelyEvent(SEARCH_BOX_QUERY_SUGGESTION_CLICK)
    }
    if (target.closest('[data-qa-id="form-searchistory-delete"]')) {
      trackOptimizelyEvent(SEARCH_BOX_CLEAN_HISTORY_CLICK)
    }
  }

  preQueryWrapper?.addEventListener('click', trackEvents)
  mobilePreQueryWrapper?.addEventListener('click', trackEvents)
}
